var _defs, _polygon, _polygon2, _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon3, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _polygon4, _path19, _polygon5, _polygon6, _path20, _rect3, _path21, _path22, _path23, _path24, _path25, _path26, _polygon7, _path27, _path28, _path29, _polygon8, _path30, _path31, _path32, _path33, _path34, _rect4, _rect5, _rect6, _rect7, _rect8, _polygon9, _polygon10, _polygon11, _rect9, _polygon12, _polygon13, _polygon14, _path35, _path36, _path37, _polygon15, _rect10, _path38, _polygon16, _path39, _path40, _path41, _path42, _path43, _rect11, _rect12, _rect13, _rect14, _path44, _path45;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEducationPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 392.71 321.69",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 207.36,
    y1: 201.12,
    x2: 213.94,
    y2: 289.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 290.33,
    y1: 212.75,
    x2: 479.54,
    y2: 118.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2494.72,
    y1: 297.56,
    x2: 2500.59,
    y2: 110.98,
    gradientTransform: "matrix(-1, 0, 0, 1, 2827.84, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 2474.52,
    y1: 224.07,
    x2: 2438.87,
    y2: 212.11,
    gradientTransform: "matrix(-1, 0, 0, 1, 2762.55, -71.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 2478.97,
    y1: 206.28,
    x2: 2505.49,
    y2: 178.45,
    gradientTransform: "matrix(-1, 0, 0, 1, 2827.84, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 2486.54,
    y1: 220.99,
    x2: 2512.79,
    y2: 202.73,
    gradientTransform: "matrix(-1, 0, 0, 1, 2762.55, -71.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -679.5,
    y1: 208.05,
    x2: -649.92,
    y2: 177.02,
    gradientTransform: "translate(991.82)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -673.16,
    y1: 220.99,
    x2: -646.9,
    y2: 202.73,
    gradientTransform: "translate(926.53 -71.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 2482.04,
    y1: 188.5,
    x2: 2504.22,
    y2: 357.66,
    gradientTransform: "matrix(-1, 0, 0, 1, 2762.55, -71.05)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 252.39,
    y1: 238.68,
    x2: 287.87,
    y2: 536.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 336.95,
    y1: 267.48,
    x2: 372.43,
    y2: 565.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 290.05,
    y1: 198.22,
    x2: 290.61,
    y2: 261.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 205.01,
    y1: 267.48,
    x2: 240.49,
    y2: 565.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 167.89,
    y1: 297.14,
    x2: 219.55,
    y2: 291.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 162.04,
    y1: 214.18,
    x2: 162.32,
    y2: 241.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 218.89,
    y1: 289.25,
    x2: 144.56,
    y2: 266.73,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M67.4,303.46c2.14,13.17,15.22,74.41,63,87.44C166.52,400.76,268,367,325.8,384c116.34,34.2,137.65-57.62,131.15-82.42-4.53-17.29-10.12-34.63-10.27-52.68-.15-18.88,6.47-37.45,7.19-56.47,1.83-48.13-32-95.38-78.13-109.19-19.75-5.9-35.9-11.93-56.51-12.1-41.83-.36-141.1,0-190,71.13-8.74,12.71-21.43,22.22-31.18,34.18-13,16-21.66,35.33-26.89,55.32A174.61,174.61,0,0,0,67.4,303.46Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#673de6",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "248.94 248.09 172.75 248.09 186.23 210.07 237.57 210.07 248.94 248.09",
    fill: "#673de6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "248.94 248.09 172.75 248.09 186.23 210.07 237.57 210.07 248.94 248.09",
    fill: "url(#linear-gradient)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101.66,
    y: 72.04,
    width: 224.79,
    height: 152.29,
    rx: 13.68,
    fill: "#673de6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M391.74,156.76V266.34H167V156.76a13.67,13.67,0,0,1,13.67-13.67H378.07A13.67,13.67,0,0,1,391.74,156.76Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#473f47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M388.36,159.37V262.68h-218V159.37a13.2,13.2,0,0,1,13.27-13.12H375.09A13.2,13.2,0,0,1,388.36,159.37Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.36,159.37V262.68h-218V159.37a13.2,13.2,0,0,1,13.27-13.12H375.09A13.2,13.2,0,0,1,388.36,159.37Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#673de6",
    opacity: 0.18,
    style: {
      isolation: "isolate"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 118.22,
    y: 47.74,
    width: 87.85,
    height: 62.06,
    fill: "#673de6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M353.72,154.16c-.13-1.87,0-3.79-.2-5.65a19.15,19.15,0,0,0-8-13.47,22.21,22.21,0,0,0-15.32-3.79c-8.75,1-16.1,7-20.31,14.57-4.79,8.61-.31,15.66,3.56,23.47,2.9,5.84,1.19,13.13-2.57,18.46-2.95,4.17-7.31,8.17-6.94,13.27.23,3.1,2.21,5.75,4.12,8.2,1.28,1.64,2.71,3.38,4.73,3.85a8.62,8.62,0,0,0,3.08,0,58,58,0,0,0,6.77-1.37c2.16-.58,4.38-1.3,6.6-1,3.76.48,6.54,3.65,8.71,6.74s4.31,6.53,7.76,8.07c2.62,1.18,5.62,1.07,8.48.83,8.35-.69,17.2-2.63,22.94-8.73a39.62,39.62,0,0,0,3.49-4.46,10.75,10.75,0,0,0,1.55-2.71c1-2.91-.6-6-2.4-8.55s-4-5-4.26-8.06c-.24-2.4.72-4.73,1-7.11.61-4.54-1.16-9.15-4-12.76a39.78,39.78,0,0,0-10.42-8.8c-3-1.88-6.2-3.83-7.6-7A11.55,11.55,0,0,1,353.72,154.16Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#fc682d"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M348.81,163.19c.66,2,1,4.15,2.15,5.95,1.4,2.28,3.78,3.74,6.14,5a11,11,0,0,1,3.4,2.37,7.37,7.37,0,0,1,1.39,2.95,12.08,12.08,0,0,1,.25,4.32,10.88,10.88,0,0,0-.23,3.67c.35,1.53,1.6,2.65,2.69,3.78a14.12,14.12,0,0,1,4.19,7.66c.4,2.94-.79,6.21-3.39,7.65a10.39,10.39,0,0,1-3,1,34.85,34.85,0,0,1-5.09.62,11.62,11.62,0,0,1-3.63-.3,13.91,13.91,0,0,1-4-2.23l-15.92-11.32a16.15,16.15,0,0,1-4.71-4.41,15.39,15.39,0,0,1-1.71-5.16c-.87-4.39-1.54-9.09.16-13.23,1.32-3.24,3.94-5.75,6.48-8.16l6.45-6.1c1.87-1.77,3.34-2.55,5-.38A22,22,0,0,1,348.81,163.19Z",
    transform: "translate(-65.29 -71.05)",
    fill: "url(#linear-gradient-2)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M359.9,221.12c5.29,5.93,7.49,13.23,11.5,20a6.07,6.07,0,0,0,2.09,2.39c1.47.8,3.3.24,4.78-.54,11.91-6.36,13-24.55,24.68-31.32,2.71-1.56,5.79-2.38,8.48-4,1-.6,2.08-1.67,1.68-2.77a2.68,2.68,0,0,0-1.78-1.34,23.27,23.27,0,0,0-9.58-1.19c-1.45.13-3.47,0-3.63-1.47a6.73,6.73,0,0,0,0-1.27c-.32-1.06-2.09-.67-2.53.35s-.11,2.18-.15,3.29a9.59,9.59,0,0,1-1.94,4.77,112.44,112.44,0,0,1-8.26,11.16c-8.44,10-10.57-5.95-17.24-9.28a5.38,5.38,0,0,0-2-.41q-8.91-.61-17.84-.36C350.27,210.82,358,219,359.9,221.12Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#f4dbbd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M342.88,184.2s17.28,7.79,18.3,9.83,0,60.24,0,60.24H300.26l3.5-61.33,17.82-7.3Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#673de6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M300.25,254.28h60.93s1-58.2,0-60.26-18.3-9.82-18.3-9.82l-21.29,1.43-17.82,7.3-1.69,29.45Z",
    transform: "translate(-65.29 -71.05)",
    fill: "url(#linear-gradient-3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M361.18,194l14.51,18.48c-2.92,8.63-14.51,19.58-14.51,19.58Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#673de6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "295.89 139.74 304.96 150.89 295.89 161.04 295.89 139.74",
    fill: "url(#linear-gradient-4)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M342.44,175.92c-.59,3.14.32,5.53.45,8.41.18,4.27-4.34,10.94-6.14,14.84-.58,1.26-1.27,2.63-2.54,3.2a5.79,5.79,0,0,1-2.81.29,8.39,8.39,0,0,1-4.06-.93c-1.64-1-2.35-3-2.92-4.86-.93-3-3.29-7.75-2.72-10.84.18-1,1.08-2,1.33-3.08a18.69,18.69,0,0,0,.23-4.23C323.19,171.2,342.44,175.92,342.44,175.92Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#f4dbbd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M342.44,175.92S340,189,332.23,188.24a9.85,9.85,0,0,1-9-7.61Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#e0be99"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M343.12,173.66a19.24,19.24,0,0,1-2.42,5.91c-3.18,4.65-10.4,6.08-15.18,3a16.63,16.63,0,0,1-5.74-7.34,34.76,34.76,0,0,1-2.69-19.7,14.13,14.13,0,0,1,2.88-7.17c2.83-3.27,7.66-4.12,12-3.89,3.93.21,8,1.19,10.95,3.7a11.77,11.77,0,0,1,3.67,11.49C345.48,164.32,344.39,169,343.12,173.66Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#f4dbbd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M252,191.6a5.07,5.07,0,0,0-2.32-1.28,26,26,0,0,0-2.66-.2c-1.83-.21-3.75-1.18-5.4-.36a3.56,3.56,0,0,0-1.77,3.19,7.76,7.76,0,0,0,1.07,3.64c2.76,5.25,6.82,7,11.59,9.81,2.51,1.48,4.26,5,6,7.45l6.31,8.74c2.58,3.57,5.2,7.19,8.65,9.94a6.22,6.22,0,0,0,1.9,1.13,5.77,5.77,0,0,0,3.78-.38c5-1.93,9.45-5.59,13.77-8.75,2-1.48,4.07-3,6.08-4.49.87-.65,2.49-1.48,3.05-2.46a5.22,5.22,0,0,0,.53-2c.76-5.9-.29-11.91-.14-17.86-6.58,7.52-14.18,15.47-23,20.32a1.87,1.87,0,0,1-.88.31,2,2,0,0,1-.9-.3,60.8,60.8,0,0,1-18.92-15.72,56.23,56.23,0,0,1-5-8.44A8.89,8.89,0,0,0,252,191.6Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#f4dbbd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M346.55,161.31a2.22,2.22,0,0,1,2.55.33,2.17,2.17,0,0,1,.4.87,7.21,7.21,0,0,1-1.05,5.16,3.84,3.84,0,0,1-.91,1.16,4.44,4.44,0,0,1-2.56.68,1.55,1.55,0,0,1-.61,0,1.21,1.21,0,0,1-.42-.32,3.4,3.4,0,0,1-.71-2.59C343.43,164.54,344.61,162.16,346.55,161.31Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#f4dbbd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M316.43,169.12a2.2,2.2,0,0,0,2.55-.32,2.16,2.16,0,0,0,.4-.87,7.16,7.16,0,0,0-1.05-5.16,4,4,0,0,0-.91-1.17,4.4,4.4,0,0,0-2.56-.68,1.39,1.39,0,0,0-.61.06,1.1,1.1,0,0,0-.42.32,3.4,3.4,0,0,0-.71,2.59C313.31,165.9,314.5,168.28,316.43,169.12Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#f4dbbd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M303.76,192.94,289.43,211c2.91,8.63,12.62,19.58,12.62,19.58Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#673de6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M348.14,165.87a4,4,0,0,1-1.19,1.62,1.41,1.41,0,0,1-1.67.09.51.51,0,0,1-.2-.26.76.76,0,0,1,.07-.51l.12-.32a.91.91,0,0,1,.13-.26c.22-.29.67-.24,1-.42s.46-.64.64-1a.85.85,0,0,1,.75-.52.72.72,0,0,1,.57.65A1.71,1.71,0,0,1,348.14,165.87Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#e0be99"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M314.44,165.23a3.94,3.94,0,0,0,1.19,1.62,1.43,1.43,0,0,0,1.68.1.54.54,0,0,0,.2-.27.8.8,0,0,0-.07-.5l-.12-.32a.79.79,0,0,0-.13-.26c-.22-.29-.67-.25-1-.43s-.46-.64-.64-1a.87.87,0,0,0-.75-.52.69.69,0,0,0-.57.64A1.68,1.68,0,0,0,314.44,165.23Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#e0be99"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M342.88,184.2l4.06,1.88-2,18.78L334.18,209S338.69,195.24,342.88,184.2Z",
    transform: "translate(-65.29 -71.05)",
    fill: "url(#linear-gradient-5)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "276.21 135.14 277.58 142.34 264.54 156.91 268.89 138 276.21 135.14",
    fill: "url(#linear-gradient-6)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M321.44,185.75l-4.06,1.87-2.32,17.24L325.78,209S321.58,191.65,321.44,185.75Z",
    transform: "translate(-65.29 -71.05)",
    fill: "url(#linear-gradient-7)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "253.18 135.14 251.8 142.34 264.84 156.91 260.49 138 253.18 135.14",
    fill: "url(#linear-gradient-8)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "247.91 183 288.13 175.83 295.89 139.74 295.89 179.91 295.89 183.22 247.91 183",
    fill: "url(#linear-gradient-9)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M328.66,147.78c.5,3,1,6.34,3.3,8.44a11.76,11.76,0,0,0,4.47,2.34,43,43,0,0,0,11.62,2.11A17.79,17.79,0,0,0,330.89,139C324,138.81,327.93,143.29,328.66,147.78Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#fc682d"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105.04,
    y: 179.76,
    width: 218.03,
    height: 11.88,
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M335.11,322.51a11.55,11.55,0,0,0,5.2,19.32v2.64h-139A13.78,13.78,0,0,1,188.22,335a13.63,13.63,0,0,1-.71-4.35,13.79,13.79,0,0,1,13.8-13.8h139v2.64A11.52,11.52,0,0,0,335.11,322.51Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#673de6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M340.31,341.83v2.64h-139A13.78,13.78,0,0,1,188.22,335c5.28.93,38.71,6.26,57.32-4.35l87.17,4.65A11.53,11.53,0,0,0,340.31,341.83Z",
    transform: "translate(-65.29 -71.05)",
    fill: "url(#linear-gradient-10)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M335.11,322.51a11.55,11.55,0,0,0,5.2,19.32v.39H257.09a11.55,11.55,0,1,1,0-23.09h83.22v.38A11.52,11.52,0,0,0,335.11,322.51Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M419.66,351.31a11.55,11.55,0,0,0,5.2,19.32v2.64h-139a13.78,13.78,0,0,1-13.09-9.45,13.63,13.63,0,0,1-.71-4.35,13.79,13.79,0,0,1,13.8-13.8h139v2.64A11.52,11.52,0,0,0,419.66,351.31Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#673de6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M424.86,370.63v2.64h-139a13.78,13.78,0,0,1-13.09-9.45c5.28.93,38.71,6.26,57.32-4.35l87.17,4.65A11.53,11.53,0,0,0,424.86,370.63Z",
    transform: "translate(-65.29 -71.05)",
    fill: "url(#linear-gradient-11)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M419.66,351.31a11.55,11.55,0,0,0,5.2,19.32V371H341.64a11.55,11.55,0,1,1,0-23.09h83.22v.38A11.52,11.52,0,0,0,419.66,351.31Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#fff"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "179.62 118.65 162.95 78.77 181.73 119.07 179.62 118.65",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M392,270.74a13.42,13.42,0,0,0-3.81,2.58,5.55,5.55,0,0,0-1.69,4.15c.15,1.87,1.49,3.41,2.9,4.63,1.61,1.42,3.57,2.9,3.7,5,1.15-.86,2.2-1.86,3.39-2.67,2.08-1.42,4.53-2.18,6.82-3.23s4.56-2.53,5.65-4.8a13.57,13.57,0,0,0,1-4.51,21.85,21.85,0,0,0,.13-5,7.25,7.25,0,0,0-2.08-4.44,13.39,13.39,0,0,0-6.19-2.62A6.63,6.63,0,0,0,396,264c-.47,1.25-.25,2.67-.71,3.92C394.71,269.38,393.3,270.08,392,270.74Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#fc682d"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M340.17,346.35a4,4,0,0,0-1.33.2,1.2,1.2,0,0,0-.8,1,1.33,1.33,0,0,0,.69,1.06c.37.24.8.38,1.17.63a6.84,6.84,0,0,0,1,.69,3,3,0,0,0,1.93-.07,25.11,25.11,0,0,1,8.81-.55,3.52,3.52,0,0,0,.86,0,2.57,2.57,0,0,0,1.76-1.77,12.41,12.41,0,0,0,.51-5.56,1.37,1.37,0,0,0-.15-.6,1.24,1.24,0,0,0-.44-.34c-2.79-1.38-4.32,1.38-6.37,2.73A15.8,15.8,0,0,1,340.17,346.35Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#ffbbab"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M407.64,305.31s.7,10.44-8.63,13.59-26.05.58-26.05.58-6.73,12.89-13.61,19l-4.4,4.35a4.39,4.39,0,0,1-4.85-2.1s13-25.91,14.75-27.85a15.59,15.59,0,0,1,7.62-5l18.62-5.86Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#473f47"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "280.08 200.06 290.07 221.27 308.53 221.14 308.38 219.54 291.4 219.35 282 199.28 280.08 200.06",
    fill: "#473f47"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M394.23,257.4c-.34.58-1.05.92-1.28,1.55s.26,1.57.53,2.34c.39,1.07.27,2.27.64,3.35a1.22,1.22,0,0,0,.38.6,1.43,1.43,0,0,0,.57.23,8.62,8.62,0,0,0,2.43.14.75.75,0,0,1,.47.06.63.63,0,0,1,.21.41,12.92,12.92,0,0,1-.1,6.18c-.17.67-.36,1.48.13,2a1.35,1.35,0,0,0,.63.32c1.54.37,3-.77,4.06-2a18,18,0,0,0,2.38-3.5,3.34,3.34,0,0,0,.41-1.13,4,4,0,0,0-.21-1.52,25.47,25.47,0,0,1-.8-5.14c-.11-2.22.05-4.53-.81-6.59a3.41,3.41,0,0,0-1.34-1.73,4.35,4.35,0,0,0-2.4-.39c-1.61.06-3.39.28-4.49,1.47C395.33,254.39,394.66,256.68,394.23,257.4Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#ffbbab"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M405.56,268.09s-6.65,3.44-8.66,6.14-5.29,4.69-4,9.8-.28,12.91-.28,12.91,2.89,9.09,10,11.39,5.15,1.57,5.15,1.57,3.77-16.85,5.25-21.54S412,267.34,405.56,268.09Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#673de6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M396.37,253.82a4.6,4.6,0,0,0,1.47,2.85c.79.73,1.76,1.24,2.58,1.94a3.24,3.24,0,0,1,1.29,2.81,1.45,1.45,0,0,1,1.76.57,1.18,1.18,0,0,1-.19,1.22,1.45,1.45,0,0,1-1.16.48,4.6,4.6,0,0,1,2.07,1.68c.57.84.85,1.84,1.37,2.72a8.72,8.72,0,0,0,2.37,2.24,3.18,3.18,0,0,1,1,1.09,17.7,17.7,0,0,0,.69,2,29,29,0,0,0,1.9,2.4,8.72,8.72,0,0,1,1.51,4.52,7.67,7.67,0,0,1,0-1.44q.25-.42.48-.87a8,8,0,0,0,.59-1.64,16.56,16.56,0,0,0,.11-3.92c0-2.8,2.64-8.07.52-10.47a20.71,20.71,0,0,0-2.69-1.91c-1.87-1.55-2.13-4.28-3.31-6.4a8.08,8.08,0,0,0-4.91-3.84C401.06,249.06,396,249.93,396.37,253.82Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#fc682d"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M403,276.85s-4.2,11.36-5,12.19,8.09,5.85,8.09,5.85,5.81-11.05,5.54-15.83S406.27,272.34,403,276.85Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#673de6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M406.05,293.35s-.31,3.66-4.8,3.59l-19.95-.28c-1.36-.7-3.22-.81-4.23-2-.49-.54-.74-1.26-1.2-1.82a4.1,4.1,0,0,0-2.43-1.3,11.92,11.92,0,0,0-2.8-.07,1.16,1.16,0,0,1,0-1.52,2.76,2.76,0,0,1,1.45-.79,8.94,8.94,0,0,1,6.76,1,8,8,0,0,0,1.91,1,5.15,5.15,0,0,0,1.52.08c5.75-.27,11.43-1.49,17.18-1.75a9.92,9.92,0,0,1,4,.42A4.7,4.7,0,0,1,406.05,293.35Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#ffbbab"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 273.78,
    y: 223.52,
    width: 2.83,
    height: 51.78,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 305.7,
    y: 223.52,
    width: 2.83,
    height: 51.78,
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 270.46,
    y: 221.27,
    width: 39.63,
    height: 4.5,
    fill: "#673de6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 270.46,
    y: 221.27,
    width: 39.63,
    height: 4.5,
    fill: "url(#linear-gradient-12)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 316.26,
    y: 247.23,
    width: 27.99,
    height: 6.69,
    rx: 1.1,
    fill: "#473f47"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "321.75 253.92 317.02 253.92 314.66 275.81 319.39 275.81 321.75 253.92",
    fill: "#473f47"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "345.81 275.81 342.68 253.92 337.95 253.92 341.88 275.81 345.81 275.81",
    fill: "#473f47"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "352.78 210.52 348.54 210.52 338.96 247.4 343.2 247.4 352.78 210.52",
    fill: "#473f47"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 168.46,
    y: 318.28,
    width: 27.99,
    height: 6.69,
    rx: 1.1,
    transform: "translate(299.63 572.2) rotate(-180)",
    fill: "#473f47"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "125.68 253.92 130.41 253.92 132.77 275.81 128.04 275.81 125.68 253.92",
    fill: "#473f47"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "101.62 275.81 104.75 253.92 109.48 253.92 105.55 275.81 101.62 275.81",
    fill: "#473f47"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "94.65 210.52 98.89 210.52 108.47 247.4 104.23 247.4 94.65 210.52",
    fill: "#473f47"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M287.72,351.32a11.55,11.55,0,0,0,5.2,19.32v2.64h-139a13.78,13.78,0,0,1-13.09-9.45,13.63,13.63,0,0,1-.71-4.35,13.79,13.79,0,0,1,13.8-13.8h139v2.64A11.52,11.52,0,0,0,287.72,351.32Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#673de6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M292.92,370.64v2.64h-139a13.78,13.78,0,0,1-13.09-9.45c5.28.93,38.71,6.26,57.32-4.35l87.17,4.65A11.53,11.53,0,0,0,292.92,370.64Z",
    transform: "translate(-65.29 -71.05)",
    fill: "url(#linear-gradient-13)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M287.72,351.32a11.55,11.55,0,0,0,5.2,19.32V371H209.7a11.55,11.55,0,1,1,0-23.09h83.22v.38A11.52,11.52,0,0,0,287.72,351.32Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#fff"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "118.22 181.82 127.48 185.7 118.22 189.33 118.22 181.82",
    fill: "#673de6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 131.23,
    y: 184.46,
    width: 184.13,
    height: 2.47,
    fill: "#673de6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M171.7,305.59s-.7,10.44,8.63,13.59c6.66,2.25,14.3,1.76,21.2,1.15,1.11-.1,3.1-.66,4.08.08,1.38,1,.69,3.79.65,5.3-.09,3.28-.17,6.55-.26,9.83,0,1.51,0,3.06-.12,4.56s-.49,3.26-.6,4.92a.5.5,0,0,0,.09.4.54.54,0,0,0,.41.11L218,345a.52.52,0,0,0,.37-.1c.18-.17.06-.47-.08-.67a9.45,9.45,0,0,0-5-3.33,4.44,4.44,0,0,1-1.32-.57c-1.27-1-.22-3.15.07-4.36l1.26-5.26,2.48-10.34c.74-3.06.92-5.39-1.44-7.52a19.92,19.92,0,0,0-7.52-4.68l-18.61-5.86Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#473f47"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "179.94 200.06 169.95 221.27 151.49 221.14 151.64 219.54 168.61 219.35 178.01 199.28 179.94 200.06",
    fill: "#473f47"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M196.36,257.4c.35.58,1.06.92,1.29,1.55s-.26,1.57-.54,2.34c-.38,1.07-.26,2.27-.63,3.35a1.22,1.22,0,0,1-.38.6,1.49,1.49,0,0,1-.57.23,8.62,8.62,0,0,1-2.43.14.75.75,0,0,0-.47.06.63.63,0,0,0-.21.41,12.92,12.92,0,0,0,.09,6.18c.18.67.37,1.48-.12,2a1.35,1.35,0,0,1-.63.32c-1.54.37-3-.77-4.06-2a18,18,0,0,1-2.38-3.5,3.34,3.34,0,0,1-.41-1.13,4,4,0,0,1,.21-1.52,25.46,25.46,0,0,0,.79-5.14c.12-2.22,0-4.53.81-6.59a3.43,3.43,0,0,1,1.35-1.73,4.32,4.32,0,0,1,2.39-.39c1.62.06,3.39.28,4.49,1.47C195.27,254.39,195.94,256.68,196.36,257.4Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#ffbbab"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M185,268.13l.14,0c2.94.73,7.22,3.41,8.18,6.39,1.21,3.74,2,8.77,1.13,12.64-.59,2.63-2,5-2.79,7.58-.67,2.13-.95,4.39-1.83,6.44A12,12,0,0,1,177,308a8.44,8.44,0,0,1-3.77-1.66,8.88,8.88,0,0,1-2.79-7.35,26.48,26.48,0,0,1,2.11-7.86l4.58-11.95C178.24,276.32,180.93,267.32,185,268.13Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#673de6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M182.63,297.52a3.8,3.8,0,0,1,.5,1.4A3.48,3.48,0,0,1,183,300a21.57,21.57,0,0,0-.59,5.94,1.39,1.39,0,0,0,.31,1,1.5,1.5,0,0,0,.89.28,6.62,6.62,0,0,0,3.4-.34,6,6,0,0,0,2.49-3.15,61.44,61.44,0,0,0,3.33-11.23,4.72,4.72,0,0,0,.18-1.9,3.73,3.73,0,0,0-1.72-2.28c-.8-.55-1.71-.95-2.48-1.55-1.52-1.16-2.64-3.27-4.71-3.54a3.08,3.08,0,0,0-3.2,2.28C179.54,289.1,181,294.23,182.63,297.52Z",
    transform: "translate(-65.29 -71.05)",
    fill: "url(#linear-gradient-14)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M187.61,276.85s4.2,11.36,5,12.19-8.08,5.85-8.08,5.85-5.82-11.05-5.54-15.83S184.33,272.34,187.61,276.85Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#673de6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M184.55,293.35s.31,3.66,4.79,3.59l20-.28c1.35-.7,3.21-.81,4.23-2,.48-.54.73-1.26,1.2-1.82a4.1,4.1,0,0,1,2.43-1.3,11.92,11.92,0,0,1,2.8-.07,1.17,1.17,0,0,0,0-1.52,2.8,2.8,0,0,0-1.45-.79,8.94,8.94,0,0,0-6.76,1,8,8,0,0,1-1.91,1,5.15,5.15,0,0,1-1.52.08c-5.75-.27-11.43-1.49-17.18-1.75a10,10,0,0,0-4,.42A4.68,4.68,0,0,0,184.55,293.35Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#ffbbab"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 145.64,
    y: 223.52,
    width: 2.83,
    height: 51.78,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 177.57,
    y: 223.52,
    width: 2.83,
    height: 51.78,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 142.32,
    y: 221.27,
    width: 39.63,
    height: 4.5,
    fill: "#673de6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 142.32,
    y: 221.27,
    width: 39.63,
    height: 4.5,
    fill: "url(#linear-gradient-15)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M195,248.32a5.63,5.63,0,0,0-4.39-2.55,4.21,4.21,0,0,0-3.33.94c-.36.36-.63.81-1,1.16-1.07,1-2.72.88-4,1.49a5.2,5.2,0,0,0-2.49,2.84,12.48,12.48,0,0,0-.72,3.79,10.26,10.26,0,0,0,.19,3.54,5.8,5.8,0,0,0,3.52,3.77,2.45,2.45,0,0,1,1.07.56c.24.27.32.66.55.94.57.7,1.71.44,2.42-.11a9.71,9.71,0,0,1,2.09-1.67l-2-2.71a1.49,1.49,0,0,1-.41-1,1,1,0,0,1,1-.73,2.08,2.08,0,0,1,1.21.53c.29.24.73.51,1,.23a.52.52,0,0,0,.14-.32c.22-1.34-1-2.67-.64-4a.58.58,0,0,1,.19-.31.66.66,0,0,1,.46-.06,8.87,8.87,0,0,0,2.41.06C194.8,254.24,196.26,250.49,195,248.32Z",
    transform: "translate(-65.29 -71.05)",
    fill: "#473f47"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M191.38,276.54c0,.49,0,1.11-.51,1.23a1,1,0,0,1-.59-.08,9.16,9.16,0,0,1-2.16-1.1,65.28,65.28,0,0,0,1.69,12.28,1.63,1.63,0,0,0,.26.64,1.45,1.45,0,0,0,1.09.4,7.54,7.54,0,0,0,2.9-.42c-2.48-4.12-2.59-9.35-1.19-13.94a3.44,3.44,0,0,0,.22-2.11,4,4,0,0,0-2.62-1.95C190.17,273,191.26,275,191.38,276.54Z",
    transform: "translate(-65.29 -71.05)",
    fill: "url(#linear-gradient-16)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationPartner);
export default __webpack_public_path__ + "static/media/education_partner.9895799e706cfb9668fd8daf93a2ccdd.svg";
export { ForwardRef as ReactComponent };